import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPlaystationComponent } from './simple-icons-playstation.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPlaystationComponent ],
    exports:      [ SimpleIconsPlaystationComponent ],
    bootstrap:    []
})
export class SimpleIconsPlaystationModule {}
